import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import FareOptionsUI from '@stencil/dstories/src/components/SRP/FareOptions/fare-options';
import {
  searchWidgetSelector,
  specialFareOptionsSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import { getABResponse } from '@stencil/flights-utils/src/flights-utils';

import getSrpUrl from '@stencil/flights-utils/src/get-srp-url';

const SeoSrpFareOptions = () => {
  const fareOptions = useSelector(specialFareOptionsSelector);
  const [selectedFareOption, setSelectedFareOption] = useState('');
  const searchWidgetData = useSelector(searchWidgetSelector);
  const pokusResponse = getABResponse();

  if (!fareOptions || !fareOptions?.fares?.length) {
    return null;
  }

  const selectFareOption = (fareType, searchParams) => {
    setSelectedFareOption(fareType);
    window.location.href = getSrpUrl(
      searchWidgetData,
      `&${searchParams}`,
      false,
      '',
      pokusResponse?.metadataValues?.web_gi_unification,
      {
        cmpId: 'SEO',
        source: 'SEO'
      }
    );
  };

  return (
    <FareOptionsUI
      fareOptions={fareOptions}
      selectedFareOption={selectedFareOption}
      selectFareOption={selectFareOption}
    />
  );
};

export default SeoSrpFareOptions;
